module.exports = __webpack_public_path__ + "static/img/5.ab4d95e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/5.png
// module id = FEPL
// module chunks = 0